import Checkbox from "@mui/material/Checkbox";
import { observer } from "mobx-react-lite";
import { useMapStore } from "../..";
import Dropdown from "../Dropdown";
import LayersIcon from "../icons/LayersIcon";
import { maxZoom, minZoom } from "../mapConfig";
import CustomControl from "./CustomControl";
import styles from './LayersMapControl.module.css';

function LayersMapControl() {
    const mapStore = useMapStore();
    const setLayerVisibility = (layerVisibility: any) => {
        mapStore.setVisibleLayers({
            ...mapStore.visibleLayers,
            ...layerVisibility,
        });
    }

    return (
        <CustomControl>
            <Dropdown
                className={styles.layers}
                title="Layers"
                icon={<LayersIcon />}
                isAutoCloseDisabled
            >
                <ul>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.deals ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.openDeals} onChange={e => setLayerVisibility({ openDeals: e.target.checked })} /> Open Deals
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.deals ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.wonDeals} onChange={e => setLayerVisibility({ wonDeals: e.target.checked })} /> Won Deals
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.deals ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.lostDeals} onChange={e => setLayerVisibility({ lostDeals: e.target.checked })} /> Lost Deals
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.leads ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.leads} onChange={e => setLayerVisibility({ leads: e.target.checked })} /> Leads
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.leaseComps ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.leaseComps} onChange={e => setLayerVisibility({ leaseComps: e.target.checked })} /> Lease Comps
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.saleComps ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.saleComps} onChange={e => setLayerVisibility({ saleComps: e.target.checked })} /> Sale Comps
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.favorites ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.favorites} onChange={e => setLayerVisibility({ favorites: e.target.checked })} /> Favorites
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.zoning ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.zoning} onChange={e => setLayerVisibility({ zoning: e.target.checked })} /> Zoning
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.landUse ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.landUse} onChange={e => setLayerVisibility({ landUse: e.target.checked })} /> Land Use
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.iosZoning ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.iosZoning} onChange={e => setLayerVisibility({ iosZoning: e.target.checked })} /> IOS Zoning
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.parcels ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.parcels} onChange={e => setLayerVisibility({ parcels: e.target.checked })} /> Parcels
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.counties || mapStore.viewState.zoom > maxZoom.counties ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.counties} onChange={e => setLayerVisibility({ counties: e.target.checked })} /> Counties
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.aadt ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.aadt} onChange={e => setLayerVisibility({ aadt: e.target.checked })} /> AADT
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.opportunityZone ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.opportunityZones} onChange={e => setLayerVisibility({ opportunityZones: e.target.checked })} /> Opportunity Zones
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.rails ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.rails} onChange={e => setLayerVisibility({ rails: e.target.checked })} /> Rails
                        </label>
                    </li>
                    <li>
                        <label className={mapStore.viewState.zoom < minZoom.pointsOfInterest ? styles.greyout : ""}>
                            <Checkbox checked={mapStore.visibleLayers.pointsOfInterest} onChange={e => setLayerVisibility({ pointsOfInterest: e.target.checked })} /> Points of Interest
                        </label>
                    </li>
                </ul>
            </Dropdown>
        </CustomControl>
    );
}

export default observer(LayersMapControl);